import validator from 'validator';

const validateEditCoins = (data) => {
    let errors = {};

    const { coin_package_name,
        coin_count,
        play_store_product_id,
        app_store_product_id } = data;

    if (validator.isEmpty(coin_package_name)) {
        errors.coin_package_name = '이름은 필수 입력 사항입니다.';
    }
    if (!coin_count) {
        errors.coin_count = '초코는 필수 입력 사항입니다.';
    } 
    if (!play_store_product_id) {
        errors.play_store_product_id = '플레이스토어 코드는 필수 입력 사항입니다.';
    } 
    if (!app_store_product_id) {
        errors.app_store_product_id = '앱스토어 코드는 필수 입력 사항입니다.';
    } 
    // if (validator.isEmpty(file)) {
    //     errors.file = '파일을 업로드 해주세요';
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateEditCoins;